import { Outlet } from "@tanstack/react-router";
import { RootProvider } from "fumadocs-ui/provider/tanstack";
import { DocsLayout } from "fumadocs-ui/layouts/docs";
import { useFumadocsLoader } from "fumadocs-core/source/client";
import { ThemeToggle } from "@/components/motion/theme-toggle";
import { BrandLogo } from "@/components/brand-logo";
import type { getContentTree } from "../lib/loaders";

export function ContentLayout({ data }: { data: Awaited<ReturnType<typeof getContentTree>> }) {
  const { pageTree } = useFumadocsLoader(data);
  return (
    <RootProvider theme={{ enabled: false }} search={{ options: { api: "/api/content/search" } }}>
      <div
        className="content-site font-hb min-h-screen bg-hb-page text-hb-text"
        data-content-layout="documentation"
      >
        <DocsLayout
          tree={pageTree}
          nav={{ title: <BrandLogo className="h-5 w-auto" />, url: "/" }}
          themeSwitch={{ component: <ThemeToggle tooltip="Toggle theme" /> }}
          links={[
            { text: "Home", url: "/" },
            { text: "Start free", url: "/login" },
          ]}
        >
          <Outlet />
        </DocsLayout>
      </div>
    </RootProvider>
  );
}
